import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { routers } from "routers";

function App() {
  const router = createBrowserRouter(routers);
  return <RouterProvider router={router} />;
}

export default App;
